import type { HttpClient } from "../http";
import type { AnalyticsDashboardDTO, AnalyticsEventDTO } from "../types";

export function analyticsResource(http: HttpClient) {
  return {
    recordEvent: (event: AnalyticsEventDTO) =>
      http.post<AnalyticsEventDTO>("/analytics/events", event),
    getDashboard: (params?: { start?: string; end?: string }) => {
      const q = new URLSearchParams();
      if (params?.start) q.set("start", params.start);
      if (params?.end) q.set("end", params.end);
      const queryStr = q.toString() ? `?${q.toString()}` : "";
      return http.get<AnalyticsDashboardDTO>(`/analytics/dashboard${queryStr}`);
    },
    getRecentEvents: (limit: number = 50) =>
      http.get<AnalyticsEventDTO[]>(`/analytics/events/recent?limit=${limit}`),
  };
}
